import React from "react";
import { FormattedHTMLMessage, injectIntl } from "react-intl";
import {
  FormSelectChoice,
  FormFieldComponentProps,
  VerificationServiceProps,
  Country,
} from "../../../lib/types/types";
import { TypeaheadComponent } from "../../FormInputs/Typeahead/TypeaheadComponent";
import { getSafe } from "../../../lib/utils/objects";
import { getOptions } from "../../../options/options";
import { FieldLabel } from "../../FieldLabel";

export const LowIncomeOrganization = ({
  value,
  isErrored,
  onChange,
  verificationService,
  intl,
  placeholder = "",
}: FormFieldComponentProps & VerificationServiceProps) => {
  const { programId } = verificationService;

  return (
    <div className="sid-field sid-low-income-id">
      <div className="sid-l-space-top-md" />
      <FieldLabel
        text={
          <FormattedHTMLMessage id="organization" defaultMessage="Government Assistance Program" />
        }
        htmlForLabel="sid-low-income"
        id="sid-low-income-label"
        displayClasses={placeholder && "sid-h-screen-reader-only"}
      />

      <TypeaheadComponent
        className={isErrored ? "sid-text-input--error" : ""}
        countryCode={getSafe<Country>(() => verificationService.viewModel.countryChoice.value)}
        onChange={(choice: FormSelectChoice) => onChange(choice)}
        minimumSearchValueLength={getOptions().minimumOrganizationSearchLength}
        placeholder={
          placeholder ||
          intl.formatHTMLMessage({
            id: "organizationNamePlaceholder",
            defaultMessage: "Government Assistance Program",
          })
        }
        programId={programId}
        value={value}
        inputHtmlId="sid-low-income"
        openOrgSearchEnabled={verificationService.programTheme.openOrgSearchEnabled}
        orgSearchUrl={verificationService.programTheme.config.orgSearchUrl}
      />
      {isErrored ? (
        <div className="sid-field-error">
          <FormattedHTMLMessage
            id="errorId.invalidOrganization"
            defaultMessage="You must select an organization from the list"
          />
        </div>
      ) : null}
    </div>
  );
};

export const LowIncomeOrganizationComponent = injectIntl(LowIncomeOrganization);
